import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';

import EmptyState from './EmptyState';

/**
 * Список записів із серверною пагінацією.
 *
 * Замінює DataTable з однією безіменною колонкою і body-шаблоном —
 * прийом, яким у застосунку виводилися всі списки. Таблиця на телефоні
 * дає горизонтальний скрол і дрібні цілі для пальця; тут кожен запис —
 * повноцінна кнопка на всю ширину.
 */
const RecordList = ({
    items = [],
    loading = false,
    renderItem,
    emptyIcon,
    emptyTitle,
    emptyText,
    page = 1,
    pageSize = 10,
    totalRecords = 0,
    onPageChange,
}) => {
    const totalPages = Math.max(1, Math.ceil(totalRecords / pageSize));
    const showPager = totalRecords > pageSize;

    if (loading) {
        return (
            <div className="rc-empty">
                <ProgressSpinner style={{ width: '2.5rem', height: '2.5rem' }} strokeWidth="4" />
                <div className="rc-empty__text">Завантаження…</div>
            </div>
        );
    }

    if (!items.length) {
        return <EmptyState icon={emptyIcon} title={emptyTitle} text={emptyText} />;
    }

    return (
        <>
            <ul className="rc-list">{items.map(renderItem)}</ul>
            {showPager && (
                <div className="rc-list-pager">
                    <Button
                        type="button"
                        icon="pi pi-chevron-left"
                        label="Назад"
                        text
                        size="small"
                        disabled={page <= 1}
                        onClick={() => onPageChange(page - 1)}
                    />
                    <span>
                        {page} / {totalPages}
                    </span>
                    <Button
                        type="button"
                        icon="pi pi-chevron-right"
                        iconPos="right"
                        label="Далі"
                        text
                        size="small"
                        disabled={page >= totalPages}
                        onClick={() => onPageChange(page + 1)}
                    />
                </div>
            )}
        </>
    );
};

export default RecordList;
